export default __webpack_public_path__ + "static/media/eco.ba94cf59.svg";